/** iOS/Android home indicator — requires viewport-fit=cover in index.html */
export const SAFE_AREA_INSET_BOTTOM = 'env(safe-area-inset-bottom, 0px)';

/** fixed/absolute `bottom`: base offset + safe area */
export const bottomWithSafeArea = (base: string) =>
  `calc(${base} + ${SAFE_AREA_INSET_BOTTOM})`;

/** `padding-bottom`: base padding + safe area (use with bottom: 0) */
export const paddingBottomWithSafeArea = (base: string) =>
  `calc(${base} + ${SAFE_AREA_INSET_BOTTOM})`;
